/** @internal */
export type Direction = 'ltr' | 'rtl';

/**
 * Array of supported units to specify the size of a panel.
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export const panelSizeUnits = ['px', 'fr', '%', 'vw', 'rem'] as const;
/**
 * The supported units to specify the size of a panel.
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export type PanelSizeUnit = (typeof panelSizeUnits)[number];

/**
 * The size of a panel.
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export type PanelSize = number | `${number}${PanelSizeUnit}`;
